import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import "./theme.css";
import { UserStorage } from "./Context/UserContext";
import { ClinicStorage } from "./Context/ClinicContext";
import { Account } from "./Components/Account/Account";
import { RequireAuth } from "./Utils/RequireAuth";
import { Content } from "./Components/Layout/Content";
import { Login } from "./Components/Login/Login";
import { Logout } from "./Components/Login/Logout";
import { LoginCreate } from "./Components/Login/LoginCreate";
import { Today } from "./Components/Home/Today";
import { HomePage } from "./Components/Home/HomePage";
import { Contact } from "./Components/Home/Contact";
import { Appointment } from "./Components/Appointment/Appointment";
import { Professionals } from "./Components/Home/Professionals";
import { ProPage } from "./Components/Home/ProPage";
import { Request } from "./Components/Home/Request";
import { Schedule } from "./Components/Schedule/Schedule";
import { ProfilePage } from "./Components/Profile/ProfilePage";
import { Favorites } from "./Components/Home/Favorites";
import { ProfileData } from "./Components/Profile/ProfileData";
import { ListProblems } from "./Components/Profile/ListProblems";
import { ListGoals } from "./Components/Profile/ListGoals";
import { ActionPlan } from "./Components/Profile/ActionPlan";
import { Values } from "./Components/Profile/Values";
import { TerAct } from "./Components/TerAct/TerAct";
import { About } from "./Components/Home/About";
import { Practices } from "./Components/Home/Practices";
import { ListeningPresent } from "./Components/TerAct/ListeningPresent";
import { ListeningNature } from "./Components/TerAct/ListeningNature";
import { Topbar } from "./Components/Layout/Topbar";
import { Start } from "./Components/Home/Start";
import { Diary } from "./Components/Home/Diary";
import { NewAct } from "./Components/Schedule/NewAct";
import { ContentTerAct } from "./Components/Layout/ContentTerAct";
import { ListeningPractice } from "./Components/TerAct/ListeningPractice";

function App() {
  const TopbarLayout = () => (
    <>
      <Topbar />
      <Content />
    </>
  );
  const TerActLayout = () => (
    <>
      <ContentTerAct />
    </>
  );
  return (
    <UserStorage>
      <ClinicStorage>
        <Routes>
          <Route path="login/*" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          {/* <Route path="/signup" element={<Submission />} /> */}
          <Route path="/home" element={<HomePage />} />
          <Route path="/practices" element={<Practices />} />
          <Route path="/about" element={<About />} />
          <Route path="/request" element={<Request />} />
          <Route path="/register" element={<LoginCreate />} />
          <Route element={<TerActLayout />}>
            <Route path="/teract/*" element={<TerAct />} />
            <Route path="/listeningpractice/" element={<ListeningPractice />} />
            <Route path="/newact/" element={<NewAct />} />
          </Route>
          <Route element={<TopbarLayout />}>
            <Route path="/start" element={<Start />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/listening-present" element={<ListeningPresent />} />
            <Route path="/listening-nature" element={<ListeningNature />} />
            {/* <Route path="/start" element={<Today />} /> */}
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/diary" element={<Diary />} />
            <Route path="/favorites" element={<Favorites />} />
          </Route>
          <Route element={<RequireAuth />}>
            <Route element={<TopbarLayout />}>
              <Route path="/" element={<Today />} />
              <Route path="/data" element={<ProfileData />} />
              <Route path="/listproblems" element={<ListProblems />} />
              <Route path="/listgoals" element={<ListGoals />} />
              <Route path="/actionplan" element={<ActionPlan />} />
              <Route path="/values" element={<Values />} />
              <Route path="/account/*" element={<Account />} />
              <Route path="/appointment" element={<Appointment />} />
              <Route path="/pros" element={<Professionals />} />
              <Route path="/pro/:id" element={<ProPage />} />
            </Route>
          </Route>
        </Routes>
      </ClinicStorage>
    </UserStorage>
  );
}

export default App;
